export { IonModalToken } from '@ionic/angular/common';
